// extracted by mini-css-extract-plugin
export var barContainer = "_2b-0";
export var extraThin = "_2b-3";
export var fillBar = "_2b-6";
export var fillContainer = "_2b-4";
export var overflow = "_2b-8";
export var overflowContainer = "_2b-5";
export var regular = "_2b-7";
export var thick = "_2b-1";
export var thin = "_2b-2";